import createReducer from '../utils/createReducer';
import {
  HIMS_DISTRICTS_REQUEST,
  HIMS_DISTRICTS_SUCCESS,
  HIMS_DISTRICTS_FAILURE,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [HIMS_DISTRICTS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [HIMS_DISTRICTS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [HIMS_DISTRICTS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/himsDistricts.js